import {
  KUBERNETES_INTEGRATION_CONFIG_REQUEST,
  KUBERNETES_INTEGRATION_CONFIG_SUCCESS,
  KUBERNETES_INTEGRATION_CONFIG_ERROR,
  KUBERNETES_INTEGRATION_CONFIG_SET,
  KUBERNETES_INTEGRATION_CONFIG_CREATE_REQUEST,
  KUBERNETES_INTEGRATION_CONFIG_UPDATE_REQUEST,
  KUBERNETES_INTEGRATION_CONFIG_UPDATE_SUCCESS,
  KUBERNETES_INTEGRATION_CONFIG_UPDATE_ERROR,
  KUBERNETES_HELMCHART_CONFIG_REQUEST,
  KUBERNETES_HELMCHART_CONFIG_SUCCESS,
  KUBERNETES_HELMCHART_CONFIG_ERROR
} from './kubernetes-integration.type'

import ApiRest from '@/api/api-rest'

const state = {
  kubernetesIntegrationConfigReqStatus: '',
  kubernetesIntegrationConfigUpdateReqStatus: '',
  kubernetesHelmchartConfigReqStatus: '',
  kubernetesIntegrationConfig: {
    active: true,
    key: null,
    nickName: null,
    roleArn: null,
    region: null,
    cluster: null,
    scanFrequency: null
  }
}

const getters = {
  kubernetesIntegrationConfigReqStatus: state => state.kubernetesIntegrationConfigReqStatus,
  kubernetesIntegrationConfigUpdateReqStatus: state => state.kubernetesIntegrationConfigUpdateReqStatus,
  kubernetesIntegrationConfig: state => state.kubernetesIntegrationConfig,
  kubernetesHelmchartConfigReqStatus: state => state.kubernetesHelmchartConfigReqStatus
}

// Best Practice - updates state
const mutations = {
  [KUBERNETES_INTEGRATION_CONFIG_REQUEST]: state => (state.kubernetesIntegrationConfigReqStatus = 'loading'),
  [KUBERNETES_INTEGRATION_CONFIG_SUCCESS]: state => (state.kubernetesIntegrationConfigReqStatus = 'saved'),
  [KUBERNETES_INTEGRATION_CONFIG_ERROR]: state => (state.kubernetesIntegrationConfigReqStatus = 'error'),
  [KUBERNETES_INTEGRATION_CONFIG_SET]: (state, settings) => {
    state.kubernetesIntegrationConfig = settings
  },
  [KUBERNETES_INTEGRATION_CONFIG_UPDATE_REQUEST]: state =>
    (state.kubernetesIntegrationConfigUpdateReqStatus = 'inprogress'),
  [KUBERNETES_INTEGRATION_CONFIG_UPDATE_SUCCESS]: state => (state.kubernetesIntegrationConfigUpdateReqStatus = 'saved'),
  [KUBERNETES_INTEGRATION_CONFIG_UPDATE_ERROR]: state => (state.kubernetesIntegrationConfigUpdateReqStatus = 'error'),
  [KUBERNETES_HELMCHART_CONFIG_REQUEST]: state => (state.kubernetesHelmchartConfigReqStatus = 'inprogress'),
  [KUBERNETES_HELMCHART_CONFIG_SUCCESS]: state => (state.kubernetesHelmchartConfigReqStatus = 'saved'),
  [KUBERNETES_HELMCHART_CONFIG_ERROR]: state => (state.kubernetesHelmchartConfigReqStatus = 'error')
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [KUBERNETES_INTEGRATION_CONFIG_SET] (context, account) {
    context.commit(KUBERNETES_INTEGRATION_CONFIG_SET, account)
  },
  [KUBERNETES_INTEGRATION_CONFIG_REQUEST] (context, account) {
    context.commit(KUBERNETES_INTEGRATION_CONFIG_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('/integrations/configure/kubernetes')
        .then(({ data }) => {
          context.commit(KUBERNETES_INTEGRATION_CONFIG_SET, {
            active: data.active,
            nickName: data.nickName,
            roleArn: data.roleArn,
            scanFrequency: data.scanFrequency,
            key: data.key,
            region: data.region,
            cluster: data.cluster
          })
          context.commit(KUBERNETES_INTEGRATION_CONFIG_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(KUBERNETES_INTEGRATION_CONFIG_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [KUBERNETES_INTEGRATION_CONFIG_CREATE_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(KUBERNETES_INTEGRATION_CONFIG_REQUEST)
      ApiRest()
        .post('/integrations/configure/kubernetes', {
          active: payload.active,
          nickName: payload.nickName,
          roleArn: payload.roleArn,
          scanFrequency: payload.scanFrequency,
          key: payload.key,
          region: payload.region,
          cluster: payload.cluster,
          externalId: payload.externalId
        })
        .then(({ data }) => {
          let blob = new Blob([data.config], {
            type: 'text/plain'
          })
          let link = document.createElement('a')
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', `${payload.roleArn}:${payload.region}:${payload.cluster}.yml`)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
          context.commit(KUBERNETES_INTEGRATION_CONFIG_SET, payload)
          context.commit(KUBERNETES_INTEGRATION_CONFIG_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(KUBERNETES_INTEGRATION_CONFIG_UPDATE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [KUBERNETES_INTEGRATION_CONFIG_UPDATE_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(KUBERNETES_INTEGRATION_CONFIG_UPDATE_REQUEST)
      ApiRest()
        .put(`/integrations/configure/kubernetes/${payload.accountKey}`, {
          active: payload.active,
          nickName: payload.nickName,
          roleArn: payload.roleArn,
          scanFrequency: payload.scanFrequency,
          key: payload.key,
          region: payload.region,
          cluster: payload.cluster
        })
        .then(resp => {
          context.commit(KUBERNETES_INTEGRATION_CONFIG_SET, payload)
          context.commit(KUBERNETES_INTEGRATION_CONFIG_UPDATE_SUCCESS, resp)
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(KUBERNETES_INTEGRATION_CONFIG_UPDATE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [KUBERNETES_HELMCHART_CONFIG_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(KUBERNETES_HELMCHART_CONFIG_REQUEST)
      ApiRest()
        .get(`/integrations/configure/kubernetes/helmchart/${payload.uniqueId}`)
        .then(({ data }) => {
          let blob = new Blob([data.config], {
            type: 'text/plain'
          })
          let link = document.createElement('a')
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', `${payload.uniqueId}.yml`)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
          context.commit(KUBERNETES_HELMCHART_CONFIG_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(KUBERNETES_HELMCHART_CONFIG_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/integrations/kubernetes-integration-config.module.js